import { GetterNames } from '@/constants/GetterNames';
import { IState } from '@/interfaces/IState';
import { ILicense } from '@/interfaces/ILicense';
import { IInvoice } from '@/interfaces/IInvoice';
import { IArticle } from '@/interfaces/IArticle';
import { RoleNames } from '@/constants/RoleNames';
import { IOrder } from '@/interfaces/IOrder';
import * as moment from 'moment';

export default {
  [GetterNames.IS_LOGGED_IN](state: IState): boolean {
    if (localStorage.authToken) {
      state.isLoggedIn = true;
      state.authToken = localStorage.authToken;
    }

    return state.isLoggedIn;
  },
  [GetterNames.BALANCE](state: IState): number {
    return state.balance;
  },
  [GetterNames.IS_COMPANY](state: IState): boolean {
    return state.role === RoleNames.COMPANY;
  },
  [GetterNames.ROLE](state: IState): number {
    if (localStorage.role) {
      state.role = localStorage.role;
    }

    return state.role;
  },
  [GetterNames.BUSINESS_NAME](state: IState): string {
    return state.businessName;
  },
  [GetterNames.VAT_NUMBER](state: IState): string {
    return state.vatNumber;
  },
  [GetterNames.CARD_NUMBER](state: IState): number {
    return state.cardNumber;
  },
  [GetterNames.RELATION_ID](state: IState): number {
    return state.relationId;
  },
  [GetterNames.PRIMARY_LICENSE](state: IState): string {
    return state.primaryLicense;
  },
  [GetterNames.ADDRESS](state: IState): { street: string, houseNumber: string, zipCode: string, city: string } {
    return {
      street: state.street,
      houseNumber: state.houseNumber,
      zipCode: state.zipCode,
      city: state.city,
    };
  },
  [GetterNames.EMAIL](state: IState): string {
    return state.email;
  },
  [GetterNames.FULL_NAME](state: IState): string {
    return state.fullName;
  },
  [GetterNames.LICENSES](state: IState): ILicense[] {
    return state.licenses;
  },
  [GetterNames.INVOICES](state: IState): IInvoice[] {
    state.invoices.sort((orderA: IInvoice, orderB: IInvoice) => {
      // @ts-ignore
      return moment(orderB.dateTime.date) - moment(orderA.dateTime.date);
    });

    return state.invoices;
  },
  [GetterNames.ORDER_HISTORY](state: IState): IOrder[] {
    state.orders.sort((orderA: IOrder, orderB: IOrder) => {
      // @ts-ignore
      return moment(orderB.date.date) - moment(orderA.date.date);
    });

    return state.orders;
  },
  [GetterNames.ARTICLES](state: IState): IArticle[] {
    return state.articles;
  },
};
